/// #if PLATFORM === 'xd'
<template>
  <footer
    v-if="$route.name !== 'login'"
    class="appFooter"
    @click="showImportFormat(asset)"
  >
    <div class="w-100 d-flex align-items-center justify-content-between">
      <div class="font-weight-bold">Insert Format for {{ $tc(`items.${asset}.name`, 2) }}</div>
      <div>{{ getSelectedFormatText(asset) }} <img src="@/assets/xd/arrow.png" class="arrow" /></div>
    </div>
  </footer>
</template>
/// #else
<template>
  <footer
    :class="$style.footer"
  >
    <!-- <div v-if="!hasPremiumSubscription" :class="$style.promo" @click="onPromoClick">
      <div :class="$style.content">
        <b>Unlimited premium icons download</b>
        <br/> just at <strike class="mr-1">$108</strike><span>$40/year</span>
      </div>

      <div :class="$style.btnAction">
        Go Pro
      </div>
    </div> -->

    <!-- <a
      href="#"
      :class="$style.btnToggle"
      @click.prevent="visible = !visible"
    ></a> -->

    <div :class="$style.actions">
      <template v-if="showFormat">
        <span class="mr-1">Insert Format for {{ $tc(`items.${asset}.name`, 2) }}</span>
        <a
          href="#"
          class="text-primary"
          @click.prevent="showImportFormat(asset)"
        >{{ getSelectedFormatText(asset) }}</a>
      </template>

      <!-- Importing Options -->
      <template
        v-if="fillTypeSupported"
      >
        <span>
          {{ $t('footer.fill_type') }}
        </span>

        <b-dropdown
          variant="link"
          class="d-inline-block"
          toggle-class="no-styled"
          :text="selectedFillType.text"
        >
          <b-dropdown-item-button
            v-for="fill in fillTypes"
            :key="fill.value"
            :class="{ active: selectedFillType.value === fill.value }"
            :title="fill.title"
            @click="selectedFillType = fill"
          >
            {{ fill.text }}
          </b-dropdown-item-button>
        </b-dropdown>
      </template>

      <!-- Show Development Logs -->
      <!-- <div
        v-if="isDev"
        class="d-inline-block"
      >LOG: {{ log }}</div> -->

      <!-- Sizes -->
      <div class="float-right">
        <span>
          Preview
        </span>

        <b-dropdown
          variant="link"
          class="d-inline-block"
          toggle-class="no-styled"
          :text="selectedSize.text"
        >
          <b-dropdown-item-button
            v-for="size in previewSizes"
            :key="size.value"
            :class="{ active: selectedSize.value === size.value }"
            @click="selectedSize = size"
          >
            {{ size.text }}
          </b-dropdown-item-button>
        </b-dropdown>
      </div>
    </div>
  </footer>
</template>
/// #endif

<script>
import { mapState } from 'vuex'
import Platform from '@/plugin-platforms'
// import toPairs from 'lodash/toPairs'
// import { mapState } from 'vuex'
import { webUrl } from '@/lib/route'
import AuthMixin from '@/components/mixins/auth'
import ImportFormatMixin from '@/components/mixins/importFormat'

export default {
  mixins: [AuthMixin, ImportFormatMixin],

  data () {
    return {
      visible: true
    }
  },

  computed: {
    ...mapState({
      asset: state => state.settings.asset,
      log: state => state.platform.log
    }),
    isDev () {
      return process.env.NODE_ENV === 'development'
    },
    showFormat () {
      return Platform.platform.indexOf('desktop') === -1
    },
    // eslint-disable-next-line
/// #if PLATFORM === 'xd'
    isWindows () {
      const platform = require('os').platform()
      return platform.match(/^win(.)*/) !== null || false
    }
    // eslint-disable-next-line
/// #endif
  },

  watch: {
    visible (value) {
      this.$store.commit('scroll/setShow', { key: 'footer', value })
    }
  },

  methods: {
    onPromoClick () {
      let url = webUrl('subscription-checkout', {
        billing_period: 'year',
        code: 'N6E5EIM',
        members: '1',
        plan_id: '15',
        quantity: '2000',
        type: 'personal'
      })
      Platform.openURL(url)
    }
  }
}
</script>

/// #if PLATFORM !== 'xd'
<style lang="scss" module>
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: $zindex-fixed;

  // .promo {
  //   padding: 7px 0 7px 10px;
  //   background: $typo-light-1;
  //   color: $bg-light-3;
  //   line-height: 14px;
  //   display: flex;
  //   align-items: center;
  //   justify-content: space-between;
  //   cursor: pointer;

  //   .btnAction {
  //     background: #9999FF;
  //     color: #000099;
  //     padding: 6px 10px;
  //     border-top-left-radius: 5px;
  //     border-bottom-left-radius: 5px;
  //     text-transform: uppercase;
  //     font-weight: bold;
  //   }

  //   span {
  //     color: #EC5F8D;
  //   }
  // }

  .actions {
    padding: 9px 10px;
    font-size: 11px;
    border-top: 1px solid var(--border-1);
    background-color: var(--bg-2);
    z-index: $zindex-fixed;
    color: var(--typo-3);
    transition: $transition-base;
  }

  .btnToggle {
    border: 1px solid;
    border-color: var(--border-1) var(--border-1) transparent var(--border-1);
    display: block;
    right: map-get($spacers, 3);
    padding: 4px 8px;
    width: 24px;
    height: 13px;
    position: absolute;
    top: 0;
    margin-top: -13px;
    // z-index: $zindex-fixed;
    background: inherit;
    @include border-top-radius($border-radius);

    &:after {
      @include arrow-fill('bottom', var(--border-1), 3px);
      position: initial;
      margin-top: -3px;
    }
  }

  &.hidden {
    transform: translateY(100%);

    .btnToggle:after {
      @include arrow-fill('top', var(--border-1), 3px);
      position: initial;
      margin-top: 0;
    }
  }
}
</style>
/// #endif
